import { create } from "zustand"

// Lets a page announce a human label for its own path once the data behind
// a dynamic segment (an event id, a team id, ...) has loaded, so
// DashboardLayout's breadcrumb never has to show a raw UUID.
interface BreadcrumbState {
  labels: Record<string, string>
  setLabel: (path: string, label: string) => void
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  labels: {},
  setLabel: (path, label) =>
    set((s) => (s.labels[path] === label ? s : { labels: { ...s.labels, [path]: label } })),
}))
